import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
    Table,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
// core components
import { connect } from 'react-redux';
import { getAllUsers, deleteDriver, addWalletAmount, getAllSms } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import { Input } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
const PAGE_LIMIT = 10
const styles = {
    typo: {
        paddingLeft: '25%',
        marginBottom: '40px',
        position: 'relative'
    },
    note: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        bottom: '10px',
        color: '#c0c1c2',
        display: 'block',
        fontWeight: '400',
        fontSize: '13px',
        lineHeight: '13px',
        left: '0',
        marginLeft: '20px',
        position: 'absolute',
        width: '260px'
    },
    cardCategoryWhite: {
        color: 'rgba(255,255,255,.62)',
        margin: '0',
        fontSize: '14px',
        marginTop: '0',
        marginBottom: '0'
    },
    cardTitleWhite: {
        color: '#FFFFFF',
        marginTop: '0px',
        minHeight: 'auto',
        fontWeight: '300',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: '3px',
        textDecoration: 'none'
    }
};

const useStyles = makeStyles(styles);

const UsersTable = (props) => {
    const classes = useStyles();
    const [modal, setModal] = useState(false);
    const [walletModal, setWalletModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [walletMoney, setWalletMoney] = useState(null)
    const [page, setPage] = useState(1);

    const toggle = () => setModal(!modal);
    const toggleWallet = () => setWalletModal(!walletModal);
    const toggle2 = () => setModal2(!modal2);

    const [itemDelete, setItemDelete] = useState(0);
    const [itemId, setItemId] = useState(null);

    const handleWalletMoneyChange = (event) => {
        setWalletMoney(event.target.value)
    }

    useEffect(() => {
        props.getAllSms(1);
    }, []);

    const handleDelete = (id) => {
        // props.deleteDriver(id).then((data) => {
        //   if (data) {
        //     props.getAllUsers(1);
        //   }
        // });
    };
    const handlePagination = (event, value) => {
        setPage(value);
        props.getAllSms(value);
    };


    return (
        <>
            <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                    All SMS
        </h4>
            </CardHeader>
            <Table hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Phone</th>
                        <th>SMS Body</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {props.allSms?.map((item, i) => (
                        <tr key={item.id}>
                            <th scope="row">{i + 1 + (page ? (page - 1) * PAGE_LIMIT : 0)}</th>
                            <td>{item.phone_numbers}</td>
                            <td>{item.message}</td>
                            <td>{item.status}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Pagination
                count={props.pageCount && Math.ceil(props.pageCount / PAGE_LIMIT)}
                color="primary"
                page={page}
                onChange={handlePagination}
            />
            <Link to="/admin/add-sms">
                <a
                    classsName="float-button"
                    style={{
                        position: 'fixed',
                        width: '60px',
                        height: '60px',
                        bottom: '80px',
                        right: '20px',
                        backgroundColor: '#A742B9',
                        color: '#FFF',
                        borderRadius: '50px',
                        textAlign: 'center',
                        boxShadow: '2px 2px 3px #A742B9'
                    }}
                >
                    <i
                        className="fa fa-plus my-float-button"
                        style={{ fontWeight: 600, marginTop: '22px' }}
                    >
                        {' '}
            Add
          </i>
                </a>{' '}
            </Link>
        </>
    );
};

const mapStateWithProps = (state) => ({
    allSms: state.admin.allSms,
    pageCount: state.admin.allSmsCount
});
const mapDispatchWithProps = (dispatch) => {
    return {
        getAllSms: (id) => dispatch(getAllSms(id, PAGE_LIMIT)),
        addWalletAmount: (id, amount) => dispatch(addWalletAmount(id, amount)),
    };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(UsersTable);
